<template>
  <div>
    <div class="novoTemplate">
        <div class="categoria">
        <label class="labelsearch margem">Categoria:</label>
            <select v-model="form.categoria" name="statusVistoria" class="form-control" id="exampleFormControlSelect2">
                <option :value="null">Selecione a categoria do template</option>
                <option v-for="data in dataAtividade" v-bind:key="data.id" :value="data.id">{{data.descricao}}</option>
            </select>
        </div>
        <div class="descricao">
            <label class="labelsearch margem">Descrição da Atividade:</label>
            <select v-model="form.descricao" name="statusVistoria" class="form-control" id="exampleFormControlSelect2">
                <option :value="null">Selecione a descrição do template</option>
                <option v-for="data in dataAtividadeDescricao" v-bind:key="data.id" :value="data.id">{{data.descricao}}</option>
            </select>

            <div class="d-flex container_cancel_save">
                <div class="cancelar">
                    <button class="button-cancel" @click="cancel">CANCELAR</button>
                </div>
                <div class="criar" v-if="clone != null">
                 <button class="button-save" @click="postClonarTemplateWeb">{{clone != null ? 'CLONAR' : 'ADICIONAR'}}</button>
                </div>
                <div class="criar" v-else-if="editar != null">
                 <button class="button-save" @click="postEditarTemplateWeb">EDITAR</button>
                </div>
                <div class="criar" v-else>
                 <button class="button-save" @click="postCriarTemplateWeb">ADICIONAR</button>
                </div>
            </div>

        </div>

    </div>
    <b-modal ref="msg-clonagem"
      size="md"
      centered
      title="novo template"
      :hide-footer="true"
      :no-close-on-backdrop="true"
      :no-close-on-esc="true">
      <template #modal-title>
          <div class="header-title">Clonagem realizada com sucesso!</div>
      </template>
      <div class="title-popupclone">
        Deseja ser direcionado a {{ clonagemGerada.codigoAtividade }}?
      </div>
      <div class="d-flex container_cancel_save">
          <div class="cancelar">
              <button class="button-cancel" @click="keepPage">CANCELAR</button>
          </div>
          <div class="criar">
            <button class="button-save" @click="goToClone">RETORNAR</button>
          </div>
      </div>
    </b-modal>
   </div>

</template>

<script>
import newTemplate from './newTemplate'
export default newTemplate
</script>

  <style scoped>

 .novoTemplate {
    padding: 0.5rem 3rem 0.5rem 3rem
 }
 .descricaoArea{
    width: 100%;
    height: 5rem;
    border-color: #b3b3b3;
    border-radius: 1px;
 }
 .header-title{
  color: white;
  font-weight: bold;
  font-size: 16px;
  font-family: 'Segoe UI';
}
.btn-generate-lote:hover{
    background: #024d2a;
}
.button-cancel,
.button-save{
  margin-top: 10;
  font-size: 12PX;
  outline: transparent;
  border: transparent;
  border-radius: 4px;
  text-transform: uppercase;
  width: 190px;
  height: 40px;
}

 .container_cancel_save{
  justify-content: center;
  width: 100%;
  margin-top: 1.5rem;
  column-gap: 10px;
 }

.button-cancel{
  background-color: #b60000;
  color: white;
}
.button-save{
  background-color: darkgreen;
  color: white;
}
.container_cancel_save{
  justify-content: center;
  width: 100%;
  margin-top: 1.5rem;
  column-gap: 10px;
 }
 .title-popupclone{
    display: flex;
  justify-content: center;
 }
  </style>



// WEBPACK FOOTER //
// src/views/private/apr/templateApr/components/newTemplate/newTemplate.vue